module.exports = __webpack_public_path__ + "media/crypto/gusd-952ecbca.png";